
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"stroke-width":"1.2","d":"M12.5 11.59v6.82a.85.85 0 001.32.71l5.12-3.41a.86.86 0 000-1.42l-5.12-3.41a.85.85 0 00-1.32.71z"}}),_c('circle',{attrs:{"stroke-width":"1.6","cx":"15","cy":"15","r":"11.87"}})])])
          )
        }
      }
    